import Dtree from './tree'
Dtree.install = function (Vue) {
  Vue.component(Dtree.name, Dtree)
}
export default Dtree
